module.exports = __webpack_public_path__ + "img/ad_coupon_1@2x.e613014f.png";